import React, {Component} from 'react';
import {connect} from 'react-redux';
import $ from "jquery";
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';

import {castPollingVote} from "../../actions/pollingAction";
import LinearDeterminate from "./progressbar";

import './polling.css';

class PollingOptionDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentFeed         : {},
      toggleStatus        : '',
      toggle_feed_id      : '',
      urlFeedId           : this.props.urlFeedId, 
      optionDetails       : this.props.optionDetails, 
      voteStatus          : this.props.voteStatus, 
      currentActiveImage  : 0,
      carousalFeed        : 0
    };
    this.castVote =  this.castVote.bind(this);
   
  }
  componentDidMount(){
   
  }
  


  UNSAFE_componentWillReceiveProps(nextProps,prevProps){
    if(nextProps.pollingvote != this.props.pollingvote){
      if(this.state.urlFeedId == nextProps.pollingvote.poll_details.feed_id){
        this.setState({
           optionDetails       : nextProps.pollingvote.poll_details.poll_details, 
           voteStatus          : 1, 
        });
      }

    }else if(nextProps.optionDetails != this.props.optionDetails){

      this.setState({
         urlFeedId           : nextProps.urlFeedId, 
         optionDetails       : nextProps.optionDetails, 
         voteStatus          : nextProps.voteStatus, 
      });
    } 
  }

  castVote(optionid){

    if(this.state.voteStatus == 1){
      ToastsStore.error('Already voted')
    }else{

      let param = {
        feed_id   : this.state.urlFeedId,
        answer_id : optionid
      }
      this.props.castPollingVote(param);
    }
    
  }
  
  render() {
    let optionList = this.state.optionDetails || [];
    return (
           (optionList).map((item, index) => {
             return(
              <div key={index}>
                <div className={(item.answer_media != '') ? "polling-progress-withimg" : "polling-progress"} onClick={() => this.castVote(item.answer_id)}>
                  {
                    (item.answer_media != '') ? 
                        <div className="polling-view-opt-img">
                          <img src={item.answer_media} />
                        </div>
                      : null
                  }
                    
                  <div className="polling-view-secright">
                      <div className="polling-view-opt-name">{item.answer} &nbsp;
                          {(item.vote_status == 1) ?
                             <i className="fa fa-check i-vote" aria-hidden="true"></i>
                             : null
                          }
                      </div>
                      {
                        (this.state.voteStatus == 1) ? 
                          <LinearDeterminate percentage = {item.vote_percent} />
                        : null
                      }
                      {
                        (this.state.voteStatus == 1) ? 
                          <div className="polling-view-opt-percnt">
                            <span className="polling-view-percnt">{item.vote_percent}%</span>
                            <span className="polling-view-view">{item.total_vote} votes</span>
                          </div>

                          : null 
                      }
                      
                  </div>
                  <div className="clearfix" />
                </div>
                <div className="clearfix" />
              </div>    
             ); 
              
           })
    );
  }
 
}
const mapStateToProps = state => {
  return {
    pollingvote : state.castvote.castVote
  }
}
const mapDispatchToProps = dispatch => {
  return {
    castPollingVote: bindActionCreators(castPollingVote, dispatch),
   
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PollingOptionDetails));
